import { __extends } from "tslib";
import { deserializeAws_json1_1DetectLabelsCommand, serializeAws_json1_1DetectLabelsCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DetectLabelsCommand = /** @class */ (function (_super) {
    __extends(DetectLabelsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DetectLabelsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DetectLabelsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DetectLabelsCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DetectLabelsCommand(input, context);
    };
    DetectLabelsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DetectLabelsCommand(output, context);
    };
    return DetectLabelsCommand;
}($Command));
export { DetectLabelsCommand };
//# sourceMappingURL=DetectLabelsCommand.js.map